export const dateConfig = {
  DATE_FORMAT: 'dd, DD.MM.YYYY',
  SHORT_DATE_FORMAT: 'DD.MM.YY',
  INPUT_DATE_FORMAT: 'DD.MM.YYYY',
  TIME_FORMAT: 'HH:mm',
  DATE_TIME_FORMAT: 'DD.MM.YYYY HH:mm',
}
